import { amountToDisplayValue } from '@billy/design-system'

import { calculateConvertedAmount } from '@features/paymentReconciliationModal/utils'

interface GetDisplayAmountParams {
  amount: number
  itemCurrencyId?: string | null
  accountCurrencyId?: string
  exchangeRate?: number | null
}

export const getDisplayAmount = ({
  amount,
  itemCurrencyId,
  accountCurrencyId,
  exchangeRate,
}: GetDisplayAmountParams): string => {
  const isCrossCurrency = itemCurrencyId !== accountCurrencyId
  const currencyCode = itemCurrencyId || accountCurrencyId

  if (!isCrossCurrency || !itemCurrencyId || !accountCurrencyId || !exchangeRate) {
    return `${amountToDisplayValue(amount, false)}${currencyCode ? ` ${currencyCode}` : ''}`
  }

  const convertedAmount = calculateConvertedAmount(exchangeRate, amount)

  return `${amountToDisplayValue(convertedAmount, false)} ${accountCurrencyId} (${amountToDisplayValue(amount, false)} ${itemCurrencyId})`
}
